Promise.all([import("angular").then(dep => dep.default)]).then(deps => {
    let [angular] = deps;

    var app = angular.module("tapAssetManager");

    var sourceParam, defaultSourceId;

    app.factory("assetEmbedCodeGenerator", [
        function() {
            function addMetaDataParams(url, meta) {
                var l = url.indexOf("?") === -1 ? "?" : "&";
                angular.forEach(meta, function(md) {
                    if (md.key === null || md.value === null) return;

                    url += l + "tm_" + encodeURIComponent(md.key) + "=" + encodeURIComponent(md.value);
                    l = "&";
                });

                return url;
            }

            function createIntegrationImageSnippet(integrationUrl, assetUrl) {
                return (
                    '<a href="' +
                    integrationUrl +
                    '" target="_BLANK" rel="nofollow"><img src="' +
                    assetUrl +
                    '" border="0"></a>'
                );
            }

            function createIntegrationIframeSnippet(assetUrl, dimensions) {
                return (
                    '<iframe src="' +
                    assetUrl +
                    '" width="' +
                    (dimensions ? dimensions.width : "100%") +
                    '" height="' +
                    (dimensions ? dimensions.height : "100%") +
                    '" style="border:0;"></iframe>'
                );
            }

            function createIntegrationYoutubeSnippet(assetUrl, videoId, assetId) {
                var unique = "player" + assetId;

                return (
                    '<div id="' +
                    unique +
                    '"></div><p><a href="' +
                    assetUrl +
                    '">' +
                    assetUrl +
                    '</a></p><script src="http://www.youtube.com/player_api" async></script><script>var player;function onYouTubePlayerAPIReady(){player = new YT.Player("' +
                    unique +
                    '", {videoId: "' +
                    videoId +
                    '",events: {"onStateChange": onPlayerStateChange}});}function onPlayerStateChange(event) {if(event.data === 0) {window.location = "' +
                    assetUrl +
                    '";}}</script>'
                );
            }

            function createIntegrationVimeoSnippet(assetUrl, videoId, assetId) {
                var unique = "player" + assetId;

                return (
                    '<iframe id="' +
                    unique +
                    '" src="https://player.vimeo.com/video/' +
                    videoId +
                    '?api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe><script>function onMessageReceived(e){if(!/^https?:\\/\\/player.vimeo.com/.test(e.origin))return!1;"*"===playerOrigin&&(playerOrigin=e.origin);var n=JSON.parse(e.data);switch(n.event){case"ready":onReady();break;case"finish":onFinish()}}function post(e,n){var i={method:e};n&&(i.value=n);var a=JSON.stringify(i);player.contentWindow.postMessage(a,playerOrigin)}function onReady(){post("addEventListener","finish")}function onFinish(){window.location = "' +
                    assetUrl +
                    '";}var player=document.getElementById("' +
                    unique +
                    '"),playerOrigin="*";window.addEventListener?window.addEventListener("message",onMessageReceived,!1):window.attachEvent("onmessage",onMessageReceived,!1);</script>'
                );
            }

            function createIntegrationTextlinkSnippet(integrationUrl, assetUrl, assetValue, selectedSnippetType) {
                if (selectedSnippetType == "link") {
                    return integrationUrl;
                }

                return '<a href="' + integrationUrl + '" target="_BLANK" rel="nofollow">' + assetValue + "</a>";
            }

            function createIntegrationReferrallinkSnippet(integrationUrl, assetUrl, assetValue) {
                return integrationUrl;
            }

            function createIntegrationFeedSnippet(integrationUrl) {
                return integrationUrl;
            }

            function splitIdsc(idsc) {
                var split = idsc.split("-");

                return {
                    id: split[0],
                    secret: split[1],
                };
            }

            function serialize(obj) {
                return Object.keys(obj)
                    .reduce(function(a, k) {
                        a.push(k + "=" + decodeURIComponent(encodeURIComponent(obj[k])));
                        return a;
                    }, [])
                    .join("&");
            }

            function updateStringParameters(uri, partToUpdate, parameters) {
                var queryParams = partToUpdate.split("&");

                var newKeyValues = {};
                for (var i = 0; i < queryParams.length; i++) {
                    var pair = queryParams[i].split("=");
                    // Only add defined key value pairs
                    if (pair[1]) {
                        newKeyValues[pair[0]] = pair[1];
                    }
                }

                Object.keys(parameters).forEach(function(key) {
                    newKeyValues[key] = parameters[key];
                });

                return uri.replace(partToUpdate, serialize(newKeyValues));
            }

            /**
             * This updates or adds parameters to the hash values
             *
             * @param      {string}  uri         The uri
             * @param      {<type>}  parameters  The parameters
             * @return     {string}  { description_of_the_return_value }
             */
            function updateHashPropertyParameter(uri, parameters) {
                var url = document.createElement("a");
                url.setAttribute("href", uri);
                var urlHashPart = url.hash.substr(1);

                return updateStringParameters(uri, urlHashPart, parameters);
            }

            /**
             * This updates or adds parameters to the query string
             *
             * @param      {string}  uri         The uri
             * @param      {<type>}  parameters  The parameters
             * @return     {string}  { description_of_the_return_value }
             */
            function updateQueryStringParameter(uri, parameters) {
                var urlSearchPart = getSearchPartFromUri(uri);

                return updateStringParameters(uri, urlSearchPart, parameters);
            }

            /**
             * This grabs the query string from the uri
             *
             * @param      {string}  uri         The uri
             */
            function getSearchPartFromUri(uri) {
                var url = document.createElement("a");
                url.setAttribute("href", uri);

                return url.search.substr(1);
            }

            function getLandingPageUrl(asset, source, referralCode) {
                const defaultSource = source.title === "Default" ? true : false;
                let parametersToUpdate = {};
                if (!defaultSourceId) defaultSourceId = source.id;

                switch (asset.tracking_method) {
                    case "redirect":
                        parametersToUpdate.s = source.id;

                        return updateQueryStringParameter(asset.landing_page_url, parametersToUpdate);
                        break;
                    case "custom":
                        let queryParams = getSearchPartFromUri(asset.landing_page_url).split("&");

                        for (var i = queryParams.length - 1; i >= 0; i--) {
                            var kv = queryParams[i].toString().split("=");
                            if (kv.length > 1) {
                                if (!sourceParam && kv[1] === defaultSourceId) sourceParam = kv[0];

                                if (sourceParam && kv[0] === sourceParam) {
                                    parametersToUpdate[kv[0]] = source.id;
                                    return updateQueryStringParameter(asset.landing_page_url, parametersToUpdate);
                                }
                            }
                        }

                        return asset.landing_page_url;
                        break;

                    case "hash":
                        if (referralCode) {
                            parametersToUpdate.ref = referralCode.id;
                        }
                        if (!defaultSource) {
                            parametersToUpdate.tap_s = source.id;
                        }
                        return updateHashPropertyParameter(asset.landing_page_url, parametersToUpdate);
                        break;

                    default:
                        if (referralCode) {
                            parametersToUpdate.ref = referralCode.id;
                        }
                        if (!defaultSource) {
                            parametersToUpdate.tap_s = source.id;
                        }
                        return updateQueryStringParameter(asset.landing_page_url, parametersToUpdate);
                        break;
                }
            }

            return {
                generate: function(asset, source, referralCode, meta, options) {
                    if (!asset) return;

                    options = options || {};

                    var assetUrl =
                        asset.type !== "text_link" ? asset.type_details.url : "https://static.tapfiliate.com/pix.gif";
                    assetUrl += "?a=" + asset.id + "&s=" + source.id;

                    if (["feed", "html5_banner"].indexOf(asset.type) === -1) {
                        var landingPageUrl = getLandingPageUrl(asset, source, referralCode);
                    }

                    if (options.linkOnly) {
                        return createIntegrationTextlinkSnippet(
                            addMetaDataParams(landingPageUrl, meta),
                            assetUrl,
                            asset.value,
                            "link",
                        );
                    }

                    switch (asset.type) {
                        case "image_banner":
                            var snippet = createIntegrationImageSnippet(
                                addMetaDataParams(landingPageUrl, meta),
                                assetUrl,
                                meta,
                            );
                            break;

                        case "text_link":
                            var snippet = createIntegrationTextlinkSnippet(
                                addMetaDataParams(landingPageUrl, meta),
                                assetUrl,
                                asset.content,
                            );
                            break;

                        case "referral_link":
                            var snippet = createIntegrationReferrallinkSnippet(addMetaDataParams(landingPageUrl, meta));
                            break;

                        case "html5_banner":
                            var snippet = createIntegrationIframeSnippet(
                                addMetaDataParams(assetUrl, meta),
                                asset.type_details.dimensions,
                                meta,
                            );
                            break;

                        case "youtube_video":
                            var snippet = createIntegrationYoutubeSnippet(
                                addMetaDataParams(landingPageUrl, meta),
                                asset.type_details.video_id,
                                asset.id,
                            );
                            break;

                        case "vimeo_video":
                            var snippet = createIntegrationVimeoSnippet(
                                addMetaDataParams(landingPageUrl, meta),
                                asset.type_details.video_id,
                                asset.id,
                            );
                            break;

                        case "feed":
                            var assetSplit = splitIdsc(asset.id);
                            var sourceSplit = splitIdsc(source.id);

                            var url =
                                "https://" +
                                window.location.hostname +
                                `/api/feeds/${assetSplit.id}-${assetSplit.secret}/${sourceSplit.id}-${sourceSplit.secret}/`;
                            var snippet = createIntegrationFeedSnippet(addMetaDataParams(url, meta));
                            break;
                    }

                    return snippet;
                },
            };
        },
    ]);
});
